import React from 'react'
import { css } from '@emotion/css'
import PhoneInput from 'react-phone-number-input/input'
import { AllowedUserFieldsEnum } from 'shared/accountNameConfig'
import { useField } from 'formik'
import { useTranslatedFieldsLabels } from './useTranslatedFieldsLabels'
import { FormControl } from 'formik-chakra-ui'
import { brandColors, formColors } from 'shared/basicPalette'

type MobileNumberSignUpFieldProps = {
  isReadOnly?: boolean
}

export const MobileNumberSignUpField: React.FC<MobileNumberSignUpFieldProps> = (
  inputProps
) => {
  const [props, { error, touched }, { setValue }] = useField(
    AllowedUserFieldsEnum.PHONE_NUMBER
  )
  const label = useTranslatedFieldsLabels()[AllowedUserFieldsEnum.PHONE_NUMBER]
  return (
    <FormControl label={label} name={AllowedUserFieldsEnum.PHONE_NUMBER}>
      <PhoneInput
        className={
          // cos unable to style it using formic-chakra-ui components
          // copied from form-textInput
          css`
            border: 1px solid
              ${touched && error ? brandColors.red[500] : 'transparent'};
            height: 40px;
            border-radius: 4px;
            background-color: #f3f5f6;
            box-sizing: border-box;
            padding: 0 8px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            width: 100%;

            &:active,
            &:focus {
              border-color: var(--chakra-colors-buttonPrimary-500) !important;
            }
            &:hover {
              background-color: ${formColors.hoverBgColor} !important;
            }
          `
        }
        id={AllowedUserFieldsEnum.PHONE_NUMBER}
        {...inputProps}
        {...props}
        readOnly={inputProps.isReadOnly}
        onChange={setValue}
      />
    </FormControl>
  )
}
